<template src="./template.html"></template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import Btn from '@/components/elements/buttons';
import Dropdown from '@/components/global/dropdown';
import TableMenu from './tableMenu.vue';
import TableSearch from './tableSearch.vue';
import TableHeader from './tableHeader.vue';
import TableRow from './tableRow.vue';
import AllShipmentsRow from './allShipmentsRow.vue';
import BookedPickupsRow from "./bookedPickupsRow";
import NotPlannedPickupsRow from "./notPlannedPickupsRow";
import TableRowSkeleton from './tableRowSkeleton.vue';

const PAGE_SIZE = 50;

export default {
  name: 'DataTable',
  props: [
    'tableHead',
    'list',
    'singleLine',
    'referenceData',
    'checkbox',
    'type',
    'rowActionParameter',
    'count',
    'filterOptions',
    'tableActions',
    'tableAPI',
    'totalCount',
    'dropdown',
    'customTable',
    'tableHeader',
    'actionsOptions',
    'apiID',
    'updateIterator',
    'detailView',
    'fieldFormatterConfiguration',
    'showRowValueWithPrefix',
    'useExcludeLogic'
  ],
  components: {
    Btn,
    Dropdown,
    TableHeader,
    TableRow,
    AllShipmentsRow,
    BookedPickupsRow,
    NotPlannedPickupsRow,
    TableRowSkeleton,
    TableMenu,
    TableSearch,
  },
  data() {
    return {
      skeletonAmount: 15,
      skeletonLoadingList: 2,
      loading: false,
      loadedPage: 1,
      pageEnd: false,
      selectedItems: [],
      excludedItems: [],
      selectTotalRows: false,
      firstTimeLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      'get_active_filter',
      'get_active_filter_name',
      'get_search_term',
      'get_all_shipments_query',
      'get_data_no_found_status'
    ]),
    textForItems() {
      if (this.useExcludeLogic && this.selectTotalRows) {
        const excludedCount = this.excludedItems.length;
        const totalSelected = this.count - excludedCount;

        if (excludedCount > 0) {
          return this.$t('LBL_ITEMS_SELECTED_WITH_EXCLUDED', {
            totalSelected,
            excludedCount,
            totalCount: this.count
          });
        } else {
          return this.$t('LBL_ALL_ITEMS_SELECTED', {
            totalCount: this.count
          });
        }
      }

      if (this.selectedItems.length > 1) {
        return this.$t('LBL_MULTIPLE_ITEMS_SELECTED', {
          selectedCount: this.selectedItems.length,
          loadedCount: this.count
        });
      }
      return this.$t('LBL_SINGLE_ITEM_SELECTED', {
        selectedCount: this.selectedItems.length,
        loadedCount: this.count
      });
    },
    selectAllButtonText() {
      if (this.selectTotalRows || (this.useExcludeLogic && this.selectTotalRows)) {
        return this.$t('LBL_UNSELECT_ALL');
      }
      return this.$t('LBL_SELECT_ALL');
    },
    computedActionsOptions() {
      return this.actionsOptions;
    },
    randomIconId() {
      return `icon-${this.randomNumber()}`
    },
    hasSelections() {
      if (this.useExcludeLogic) {
        return this.selectTotalRows || this.selectedItems.length > 0;
      } else {
        return this.selectedItems.length > 0 || this.selectTotalRows;
      }
    },
    selectionPayload() {
      if (this.useExcludeLogic && this.selectTotalRows) {
        return {
          selectedList: [],
          excludeOnlyIds: this.excludedItems,
          selectTotalRows: true,
          totalSelected: this.count - this.excludedItems.length
        };
      }

      return {
        selectedList: this.selectedItems,
        excludeOnlyIds: [],
        selectTotalRows: this.selectTotalRows,
        totalSelected: this.selectedItems.length
      };
    }
  },
  mounted() {
    //Reset data not found to false
    this.$store.commit('RESET_DATA_NOT_FOUND');
    if (this.tableHead) {
      this.loading = true;
      // IF FILTER EXIST CALL FILTER PARAM BEFORE CALLING DATA
      // 1. Step - get filters from server
      this.$store.dispatch('STORE_SIDEBAR_FIELDS', {
        sidebarFields: this.filterOptions.filterFields,
        sidebarTableName: this.filterOptions.tableName,
        sidebarTableApi: this.filterOptions.tableApi,
        tableApi: this.tableActions,
      });
      this.$store.dispatch('GET_FILTERS', this.filterOptions.tableName).then((res) => {
        this.$store.dispatch('STORE_FILTERS_MENU', res.filters_json);
        if (this.$route.query.hasOwnProperty('searchTerm') || this.$route.query.hasOwnProperty('search')) {
          let searchObject = {
            searchTerm: '',
            search: [],
          };
          // Check for searchTerm
          if (this.$route.query.hasOwnProperty('searchTerm')) {
            searchObject.searchTerm = this.$route.query.searchTerm;
            this.$store.dispatch('STORE_SEARCH', searchObject.searchTerm)
          }
          // Check for search object - filter
          if (this.$route.query.hasOwnProperty('search')) {
            searchObject.search = JSON.parse(this.$route.query.search);
          }
          this.$store.dispatch('STORE_ACTIVE_FILTER', {
            name: '',
            params: searchObject.search,
          }).then(() => {
            const defaultFilter = this.getDefaultHiddenFilter();
            const effectiveFilter = (searchObject.search && Object.keys(searchObject.search).length)
              ? searchObject.search
              : defaultFilter;
            this.$store.dispatch(`TABLE_SEARCH`, {
              pageApiURL: this.filterOptions.tableApi,
              ...(Object.keys(effectiveFilter).length ? { filter: effectiveFilter } : {}),
              searchTerm: searchObject.searchTerm,
            }).then((res) => {
              this.$store.dispatch(`CLEAR_${this.tableActions}`);
              this.$store.dispatch(`STORE_${this.tableActions}`, res);
              if (this.count < this.loadedPage * PAGE_SIZE) {
                this.pageEnd = true;
              }
            }).finally(() => this.loading = false);
          });
        } else {
          // No search provided via route; include default hidden filters (e.g., type_id)
          const defaultFilter = this.getDefaultHiddenFilter();
          const payload = { pageApiURL: this.filterOptions.tableApi };
          if (Object.keys(defaultFilter).length) {
            payload.filter = defaultFilter;
          }
          this.$store.dispatch(`TABLE_SEARCH`, payload).then((res) => {
            this.$store.dispatch(`CLEAR_${this.tableActions}`);
            this.$store.dispatch(`STORE_${this.tableActions}`, res);
          }).finally(() => this.loading = false);
        }
      });
    } else {
      // IF NO FILTER NEEDED JUST CALL DATA
      this.$store.dispatch(`GET_${this.tableActions}`, {
        page: this.loadedPage,
        id: this.apiID,
      });
    }
  },
  destroyed() {
    this.$store.dispatch(`CLEAR_${this.tableActions}`);
    this.$store.dispatch('CLEAR_FILTERS_MENU');
    this.$store.dispatch('CLEAR_ACTIVE_FILTER');
    this.$store.dispatch('CLEAR_SEARCH');
    this.$store.dispatch('CLEAR_SIDEBAR_FIELDS');
  },
  methods: {
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    getDefaultHiddenFilter() {
      const hidden = {};
      try {
        const fields = this.filterOptions && this.filterOptions.filterFields ? this.filterOptions.filterFields : {};
        Object.keys(fields).forEach((key) => {
          const field = fields[key];
          if (field && field.type === 'hidden' && field.value && field.value.hasOwnProperty('value')) {
            const val = field.value.value;
            if (val !== undefined && val !== null && String(val).length > 0) {
              hidden[key] = { value: val, additional: field.value.additional || '' };
            }
          }
        });
      } catch (e) {
        // silently ignore
      }
      return hidden;
    },
    startFilter(filter) {
      this.$store.dispatch(`CLEAR_${this.tableActions}`);
      this.$store.dispatch('STORE_ACTIVE_FILTER', filter.filter).then(() => {
        this.$store.dispatch(`TABLE_SEARCH`, {
          pageApiURL: this.filterOptions.tableApi,
          filter: filter.filter.params,
          searchTerm: filter.searchTerm,
        }).then((res) => {
          this.$store.dispatch(`STORE_${this.tableActions}`, res);
        });
      });
    },
    resetFilter() {
      this.loadedPage = 1;
      this.$store.dispatch(`CLEAR_${this.tableActions}`);
      const defaultFilter = this.getDefaultHiddenFilter();
      const payload = { pageApiURL: this.filterOptions.tableApi };
      if (Object.keys(defaultFilter).length) {
        payload.filter = defaultFilter;
      }
      this.$store.dispatch(`TABLE_SEARCH`, payload).then((res) => {
        this.$store.dispatch(`STORE_${this.tableActions}`, res);
      });
      this.$store.dispatch('CLEAR_ACTIVE_FILTER');
    },
    dispatchRowAction(val) {
      this.$emit('rowAction', val);
    },
    actions(val) {
      const payload = {
        dropOption: val,
        list: this.useExcludeLogic && this.selectTotalRows ? [] : this.selectedItems,
        selectTotalRows: this.selectTotalRows,
        excludeOnlyIds: this.useExcludeLogic && this.selectTotalRows ? this.excludedItems : []
      };
      console.log('DataTable actions payload:', payload); // Debug log
      console.log('Current state - selectTotalRows:', this.selectTotalRows, 'excludedItems:', this.excludedItems, 'selectedItems:', this.selectedItems); // Debug log
      this.$emit('actionOptionTriggered', payload);
    },
    selectAll() {
      if (this.useExcludeLogic) {
        this.handleExcludeLogicSelectAll();
      } else {
        this.handleStandardSelectAll();
      }
    },
    handleStandardSelectAll() {
      if (this.selectTotalRows) {
        this.selectedItems = [];
        this.selectTotalRows = false;
      } else {
        this.selectedItems = this.list.map(item => item.id);
        this.selectTotalRows = true;
      }
    },
    handleExcludeLogicSelectAll() {
      if (this.selectTotalRows) {
        // Deselect all
        this.selectedItems = [];
        this.excludedItems = [];
        this.selectTotalRows = false;
      } else {
        // Select all
        this.selectedItems = [];
        this.excludedItems = [];
        this.selectTotalRows = true;
      }
    },
    getAvailableRowsSelectCount() {
      const array = this.list.filter(item => item.is_shared_shipment === false).map(item => item.id);
      return array.length;
    },
    updateSelectList(id) {
      if (this.useExcludeLogic) {
        this.handleExcludeLogicItemUpdate(id);
      } else {
        this.handleStandardItemUpdate(id);
      }
    },
    handleStandardItemUpdate(id) {
      const index = this.selectedItems.indexOf(id);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
        this.selectTotalRows = false;
      } else {
        this.selectedItems.push(id);
      }
    },
    handleExcludeLogicItemUpdate(id) {
      if (this.selectTotalRows) {
        // When select all is on, toggling an item means adding/removing from excluded list
        const excludedIndex = this.excludedItems.indexOf(id);
        if (excludedIndex > -1) {
          // Item was excluded, now include it (remove from excluded)
          this.excludedItems.splice(excludedIndex, 1);
        } else {
          // Item was included, now exclude it (add to excluded)
          this.excludedItems.push(id);
        }
      } else {
        // Standard behavior when select all is off
        const selectedIndex = this.selectedItems.indexOf(id);
        if (selectedIndex > -1) {
          this.selectedItems.splice(selectedIndex, 1);
        } else {
          this.selectedItems.push(id);
        }
      }
    },
    isItemSelected(id) {
      if (this.useExcludeLogic && this.selectTotalRows) {
        // When select all is on, item is selected if it's NOT in excluded list
        return !this.excludedItems.includes(id);
      }
      // Standard behavior
      return this.selectedItems.includes(id);
    },
    visibilityChanged(isVisible) {
      if (isVisible && (this.count > this.loadedPage * PAGE_SIZE)) {
        this.loading = true;
        this.loadedPage++;
        window.scrollTo(0, document.body.scrollHeight);
        this.loadMoreData().then(() => {
          this.loading = false;
          if (this.count < this.loadedPage * PAGE_SIZE) {
            this.pageEnd = true;
          } else {
            this.pageEnd = false;
          }
          if (this.useExcludeLogic && this.selectTotalRows) {
            // Don't need to do anything - new items are automatically "selected"
          } else if (this.selectTotalRows) {
            // Standard behavior - add new items to selected list
            this.selectedItems = this.list.map(item => item.id);
          }
        });
      }
    },
    async loadMoreData() {
      await this.$store.dispatch(`GET_${this.tableActions}`, {
        page: this.loadedPage,
        id: this.apiID,
        query: this.get_all_shipments_query ? '&' + this.get_all_shipments_query.substring(1) : ''
      });
    },
    resetTable() {
      this.loading = true;
      this.loadedPage = 1;
      this.pageEnd = false;
      window.scrollTo(0, 0);
      this.selectedItems = [];
      this.excludedItems = [];
      this.selectTotalRows = false;
    },
    stopLoading() {
      this.loading = false;
    },
  },
  watch: {
    count: function (val) {
      if (this.count < this.loadedPage * PAGE_SIZE) {
        this.pageEnd = true;
      } else {
        this.pageEnd = false;
      }
    },
    selectionPayload: {
      handler(newPayload) {
        this.$emit('updatedSelections', newPayload);
      },
      deep: true
    },
    updateIterator() {
      this.loadedPage = 1;
      let queryString = '';
      if (this.$route.query.hasOwnProperty('search')) {
        queryString += `&search=${this.$route.query.search}`;
        queryString += `&searchTerm=${this.$route.query.searchTerm}`;
      }
      this.$store.dispatch(`GET_${this.tableAPI}`, {
        page: 1,
        id: this.apiID,
        query: queryString,
      }).then(() => {
        this.selectedItems = [];
        this.excludedItems = [];
        this.selectTotalRows = false;
        if (this.count < this.loadedPage * PAGE_SIZE) {
          this.pageEnd = true;
        }
      });
    },
  }
}
</script>
